import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { utils } from "../common/utils";
import { RewardTrigger } from "../common/enums";

export default function ReferralsTable(props) {
  const { t } = useTranslation();

  const referrals = props.referralsList;
  const tableName = props.tableName;

  if(!referrals || referrals.length === 0) {
    return (
      props.emptyMessage &&
      <div className="alert alert-info fade show text-center margin-bottom-1x">
          <span className="alert-close" data-dismiss="alert"></span>
          <i className="icon-layers"></i>&nbsp;&nbsp;
          <strong>{t("My Referrals")}:</strong>{" "}
          {props.emptyMessage}
        </div>
    )
  }

  return (
    
      <div className="table-responsive">
        <table className="table table-hover margin-bottom-none text-center">
          <thead>
            <tr>
              <th>{t("Referral Date")}</th>
              <th>{t("Customer Full Name")}</th>
              <th>{t("Referral Status")}</th>

              <th>{t("Reward Eligibility")}</th>

              {/* <th>{t("Program Name")}</th>
              <th>{t("Program Status")}</th> */}
              <th>{t("Program Expiry Date")}</th>
              <th>{t("Discount Voucher")}</th>
            </tr>
          </thead>
          <tbody>
            {referrals.map((referral) => (
              <tr key={referral.id}>
                {/* <td><a className="text-medium navi-link" href={null} role="button" data-toggle="modal" data-target="#orderDetails">{o.id}</a></td> */}
                <td>
                  {utils.dates.getDateString(referral.referralDate)}
                </td>
                <td>
                  <span className="text-medium">
                    {referral.refereeFullName ? referral.refereeFullName : referral.referrerFullName}
                  </span>
                </td>
                <td>
                  <span className={utils.referral.getStatusColor(referral)}>
                    {t(utils.referral.getStatus(referral.referralStatus))}
                  </span>
                </td>

                <td>
                  {referral.rewardTrigger ==
                    RewardTrigger.OnRefereePurchase && (
                    <span className="text-medium">
                      {t("On Cusomter Purchasing")}
                    </span>
                  )}
                  {referral.rewardTrigger ==
                    RewardTrigger.OnRefereeRegister && (
                    <span className="text-medium">
                      {t("On Cusomter Registeration")}
                    </span>
                  )}
                </td>

                {/* <td>
                  <span className="text-medium">
                    {referral.referralProgramName}
                  </span>
                </td>
                <td>
                  <span className="text-medium">
                    {referral.referralProgramIsDeleted === true && t("Expired")}
                    {referral.referralProgramIsDeleted === false && t("Active")}
                  </span>
                </td> */}
                <td>
                  {referral.programExpiryDate ? (
                    utils.dates.getDateString(referral.programExpiryDate)
                  ) : (
                    <p>&mdash;</p>
                  )}
                </td>
                <td>
                  <span className="text-small">
                    
                      <a
                        className={`btn btn-outline-info small btn-sm text-sm ${referral.discountCode ? "" : "disabled"}`}
                        onClick={(e) => props.onShowDiscountDetails(e, referral)}
                      >
                        {referral.referralProgramName}
                      </a>
                    
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
   
  );
}
